let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5wlgr")).then(() => parcelRequire('2qpS7'));